import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Gyms from "./Gyms";
import ExportGyms from "./ExportGyms";
import SingleGym from "./SingleGym";
import PromotionalOffer from "./PromotionalOffer";
import CreatePromotionalOffer from './PromotionalOffer/CreatePromotionalOffer'
import GymTag from "./GymTag";
import CreateGymTag from './GymTag/CreateGymTag'

class GymsScreen extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact={true} path="/gyms/" component={Gyms} />
            <Route path="/gyms/gym/" component={SingleGym} />
            <Route path="/gyms/export/" component={ExportGyms} />
            <Route exact={true} path="/gyms/PromotionalOffers/" component={PromotionalOffer} />
            <Route exact={true} path="/gyms/PromotionalOffers/create/" component={CreatePromotionalOffer} />
            <Route exact={true} path="/gyms/GymTags/" component={GymTag} />
            <Route exact={true} path="/gyms/GymTags/create/" component={CreateGymTag} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default GymsScreen;
